import { get } from 'lodash';

export const getTeacher = state =>
  get(state, 'PointOfSaleState.teacher.teacher');

export const getStudentsForTeacher = state =>
  get(state, 'PointOfSaleState.teacher.students');

export const getTeacherLoading = state =>
  get(state, 'PointOfSaleState.teacher.loading');

export const getStudentForTeacher = (state, idSeed) => {
  const students = getStudentsForTeacher(state);
  return students.find(s => s.IdSeed === idSeed);
};

export const getNumStudentsProcessedForTeacher = state =>
  get(state, 'PointOfSaleState.teacher.numProcessed', 0);

export const getNumStudentsProcessingForTeacher = state =>
  get(state, 'PointOfSaleState.teacher.numProcessing', 0);

export const getTeacherWriting = state =>
  get(state, 'PointOfSaleState.teacher.writing');

export const getSelectAllStudents = state =>
  get(state, 'PointOfSaleState.teacher.selectAllStudents');



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/teacher/state/selectors.js